import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import { connect } from "react-redux";
import Moment from "react-moment";
import { Dialog } from "primereact/dialog";
import { ToastContainer, toast } from "react-toastify";
import { mappingActions, productMasterActions } from "../../actions";
import tableRequest from "../../models/tableRequest.js";
 import ExcelFile from "react-export-excel/dist/ExcelPlugin/components/ExcelFile";
 import ExcelSheet from "react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
 import ExcelColumn from "react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";

class Mapping extends React.Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.UploadMapping = this.UploadMapping.bind(this);
    this.submitseries = this.submitseries.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onHidee = this.onHidee.bind(this);
    this.onHideError = this.onHideError.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.openDialogue = this.openDialogue.bind(this);
    this.resetFormHide = this.resetFormHide.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.state = {
      IsAdd: true,
      IsClick: true,
      IsEdit: true,
      first: 0,
      rows: 5,
      totalRecords:0,
      globalFilter: null,
      sortOrder: "",
      confirm: false,
      buttonLabel: "Submit",
      buttonLabel1: "Upload Certificate",
      formHeading: "Add Mapping",
      displayModal: false,
      switchAction: false,
      showSnackbar: false,
      displayConfirmation: false,
      FileName: "",
      ProductName: "",
      MappingId: 0,
      CreatedDate: null,
      UpdatedDate: null,
      ProductId: "",
      ProductName: "",
      FromNo: "",
      ToNo: "",
      Qty: "",
      BatchNo: "",
      IsActive: true,
      AdminUserId:0,
      Issueseriesdata: [],
      selectedProduct: null,
      formError: {
        ProductId: "",
        FromNo: "",
        ToNo: "",
        Qty: "",
      },
      serieserror: {
        FromNo: "",
        ToNo: "",
        Qty: "",
      },
    };
  }
  //to trigger api on page call
  componentDidMount() {
    const userDetails = sessionStorage.getItem("user");
    const userdetailsObject = JSON.parse(userDetails);
    this.setState({
      UserId: userdetailsObject.UserId,
    });
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);
      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false,
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false,
          });
        }
      }
    }

    this.setState({
      Issueseriesdata: this.props.Issueseries,
    });
    this.props.fetchApi(this.tblResponse);
    this.props.getPrdctDDL();
  }

  componentDidUpdate(prevProps) {
  
    if (this.props.MappingData) {
      if (prevProps.MappingData !== this.props.MappingData) {
        if (this.props.MappingData) {
          var e = this.props.MappingData;
          this.setState({
            totalRecords: e[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }

    // if (prevProps.MaxFromNo != this.props.MaxFromNo) {
    //   this.setState({
    //     FromNo: this.props.MaxFromNo,
    //   });
    // }
     if (
    prevProps.MaxFromNo !== this.props.MaxFromNo &&
    this.state.MappingId === 0 // ✅ sirf Add case me
  ) {
    this.setState({
      FromNo: this.props.MaxFromNo,
    });
  }

 
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  onPage(event) {
    this.props.loadingData(true);
    this.getLazyLoadingValues(event);
    this.props.fetchApi(this.tblResponse);
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchApi(this.tblResponse);
  }

  getDropValue() {
    let productId = "";
    this.props.ProductData.filter((x) => {
      if (x.ProductId === this.state.ProductId) {
        productId = x.ProductId;
      }
    });
    return productId;
  }
  switchToggleConfirm = (e) => {
    this.setState({ confirm: true, displayConfirmation: false });
    const formData = {
      MachineId: this.state.MachineId,
    };
    this.props.inActiveRow(this.state.MachineId);
  };

  handleChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }

  onFileChange = (event) => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  };
  //to validate form data
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;

    switch (name) {
      case "ProductId":
        if (!value) {
          IsValid = false;
          errors.ProductId = "Please select Product";
        } else errors.ProductId = null;
        break;
      case "FromNo":
        if (!value) {
          IsValid = false;
          errors.FromNo = "Please enter From No";
        } else {
          if (!value.toString().match(/^[0-9]+$/.exec(value))) {
            IsValid = false;
            errors.FromNo = "Please enter only number.";
          } else errors.FromNo = null;
        }
        break;
      case "Qty":
      const qtyVal = parseInt(value);
      const fromVal = parseInt(this.state.FromNo);
      const toVal = parseInt(this.state.ToNo);

    errors.Qty = null;

    // Not a valid number
    if (isNaN(qtyVal) || qtyVal < 1) {
        IsValid = false;
        errors.Qty = "Please enter a valid quantity.";
        break;
    }

    // If FromNo is entered and valid
    if (!isNaN(fromVal) && fromVal > 0) {
        const newToNo = fromVal + qtyVal - 1;

        // Set ToNo automatically
        this.setState({ ToNo: newToNo });

        // Validate Qty if ToNo already exists
        if (!isNaN(toVal) && toVal > 0) {
            const exactQty = toVal - fromVal + 1;

            // if (qtyVal !== exactQty) {
            //     IsValid = false;
            //     errors.Qty = `Quantity must be exactly (${exactQty}).`;
            // }
        }
    } else {
        // FromNo is empty
        this.setState({ ToNo: 0 });
    }
       default:
     break;

    }

    return IsValid;
  }
  //to get current date
  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  //to submit series data
  submitseries(event) {
    event.preventDefault();

    this.props.onHideShoww(false);
  }

  submitForm(event) {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = this.state.formError;

    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateForm(val, key);
      if (!valid) {
        this.setState({ checkerror: isfrmvalid });
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      const ddlValu = this.getDropValue();

      const formData = {
        MappingId: this.state.MappingId,
        ProductId: this.state.ProductId,
        FromNo: this.state.FromNo,
        ToNo: this.state.ToNo,
        Qty: this.state.Qty,
        BatchNo: this.state.BatchNo,
        CreatedBy: JSON.parse(sessionStorage.getItem("UserData")),
        UpdatedBy: JSON.parse(sessionStorage.getItem("UserData")),
        CreatedDate:
          this.state.MappingId > 0
            ? this.state.CreatedDatee
            : this.getCurrentDateMMDDYYY(),
        UpdatedDate:
          this.state.MappingId > 0 ? this.getCurrentDateMMDDYYY() : null,
        ProductName: ddlValu != null ? ddlValu : "",
        TotalRows: this.state.totalRecords,
      };

      if (this.state.MappingId == 0) {
        this.props.createMapping(formData, this.tblResponse);        
        this.props.fetchApi(this.tblResponse);
        this.resetForm();

      } else {
        this.props.updateMapping(formData,this.tblResponse);
        this.props.fetchApi(this.tblResponse)
        this.resetForm();;
      }
    }
  }

  UploadMapping(event) {
    event.preventDefault();
    let isfrmvalid =
      document.querySelector('input[type="file"]').files &&
      document.querySelector('input[type="file"]').files[0] != null
        ? true
        : false;
    var file = document.querySelector('input[type="file"]').files[0];

    if (isfrmvalid) {
      ;
      var data = new FormData();
      data.append("Inputfile", file);
      data.append("CreatedBy", this.state.UserId);
      this.props.UploadMapping(data, this.tblResponse);
      setTimeout(() => {
        this.resetForm();
      }, 1000);
    } else {
    }
  }

  //to reset form
  resetForm() {
    this.setState({
      ProductId: "",
      FileName: "",
      MappingId: 0,
      //FromNo: "",
      ToNo: "",
      Qty: "",
      BatchNo: "",
      // Location: '',
      // DocURL: '',
      formError: {
        FromNo: "",
        ToNo: "",
        Qty: "",
        // BatchNo: '',
        // Location: '',
        // DocURL: '',
        ProductId: "",
      },
    });

    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
      return errors[key];
    });    
  }

  //to reset form on hide
  resetFormHide() {
    this.setState({
      ProductId: "",
      MappingId: 0,
      FromNo: "",
      ToNo: "",
      Qty: "",
      BatchNo: "",      
      formError: {
        FromNo: "",
        ToNo: "",
        Qty: "",       
        ProductId: "",
      },
    });

    let errors = this.state.formError;
    Object.entries(errors).map(([key]) => {
      errors[key] = "";
      return errors[key];
    });
  }
  //to hide function
  onHide() {
    this.props.onHideShow(false);
    this.resetFormHide();
  }

  openDialog() {
    this.props.onHideShow(true);
    this.setState({ buttonLabel: "Submit", formHeading: "Add Mapping",MappingId:0,FromNo: this.props.MaxFromNo || "", });

    this.props.getToNumber();
  }

  onHidee() {
    this.props.onHideShoww(false);
  }

  onHideError() {
    this.props.onHideShowError(false);
  }

  openDialogue() {
    this.props.onHideShoww(true);
    this.setState({ buttonLabel: "Submit", formHeadingg: "Available Series" });
    this.props.GetAvailableseries(this.tblResponse);
  }

  onRowSelect(event) {
    this.setState({
      FromNo: event.data.FromNo,
      ToNo: event.data.ToNo,
      Qty: event.data.ToNo - event.data.FromNo + 1,
    });
    this.onHidee();
  }

  //to get format of date
  UpdatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }
  //to get format of date
  CreatedDateTemplate(rowData) {
    if (rowData.CreatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }

  //to edit rowdata
  actionBodyTemplate(rowData, i) {
    const editMode = (e) => {
      this.setState({
        buttonLabel: "Update",
        formHeading: "Update Mapping",
        displayModal: true,
        ProductId: rowData.ProductId,
        MappingId: rowData.MappingId,
        FromNo: rowData.FromNo,
        ToNo: rowData.ToNo,
        Qty: rowData.Qty,
        BatchNo: rowData.BatchNo,
        CreatedDate: rowData.CreatedDate,
      });
    };
    return <Button icon="pi pi-pencil" onClick={editMode} />;
  }
  //to export data
  exportCSV() {
    this.dt.exportCSV();
  }

  //to render html
  render() {
    const renderFooter = (name) => {
      return (
        <div>
          {/* <Button label="No" icon="pi pi-times" onClick={() => this.setState({ displayConfirmation: false })} className="p-button-text" />
                    <Button label="Yes" icon="pi pi-check" onClick={this.switchToggleConfirm} autoFocus /> */}
        </div>
      );
    };

    const header = (
      <div className="table-header row my-3" >

        <div className="col-md-2 mb">
          <h4>Mapping</h4>
        </div>
        <div className="col-md-3 layoutright db">
        {/* <ExcelFile
            filename={"SampleMapping"}
            element={<Button className="ml-4">Download Sample Excel</Button>}
          > */}
            {/* <ExcelSheet
              name={"Sample"}
              data={[
                {
                  ProductCode: "1210H01",
                  FromNo: 1,
                  Qty: 10,
                  ToNo: 10,
                  BatchNo: "BX009",
                },
              ]}
            > */}
              {/* <ExcelColumn label="ProductCode" value="ProductCode" />
              <ExcelColumn label="FromNo" value="FromNo" />
              <ExcelColumn label="Qty" value="Qty" />
              <ExcelColumn label="ToNo" value="ToNo" />
              <ExcelColumn label="BatchNo" value="BatchNo" />
            </ExcelSheet>
          </ExcelFile>  */}

        </div>
       
         
          <div className="col-md-3 layoutright">
         
            {/* <input className="mapping-buttone"
              type="file"
              name="file"
              onChange={this.handleChange}
              id="file"
              aria-label="File browser example"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ></input>
            <span
              data-content={this.state.FileName}
              className="file-custom"
            ></span>
       
          
          {this.state.IsAdd === true ? (
            <Button
            className="btn-warning input-group-btn"
              label="Upload"
              onClick={this.UploadMapping}
            />
          ) : (
            ""
          )}

          {this.state.formError.file !== "" ? (
            <div className="error mb-2">{this.state.formError.file}</div>
          ) : (
            ""
          )}  */}

          </div>
          
          <div className="col-md-4 search layoutright" >
          <span className="p-input-icon-left mr-2">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>
          {this.state.IsAdd === true ? (
            <Button
              className="mr-2"
              icon="pi pi-plus"
              label="Add"
              onClick={this.openDialog}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    );

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />
        <div className="card">
          <DataTable
            value={this.props.MappingData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20, parseInt(this.state.totalRecords)]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            {/* <Column field="MappingId" header="Mapping Id" sortable></Column> */}
            <Column field="ProductName" header="Product Name" sortable
            style={{ width: '400px', minWidth: '50px' }}
            ></Column>
            <Column field="FromNo" header="From No" sortable></Column>
            <Column field="ToNo" header="To No" sortable></Column>
            <Column field="Qty" header="Quantity" sortable></Column>
            <Column field="BatchNo" header="Batch No" sortable></Column>
            {/* <Column field="loyalitypnt" header="Loyality Point " sortable></Column> */}
            
          </DataTable>
        </div>
        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          {/* <form onSubmit={this.submitForm}> */}
           <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 pt-2">
                  <FormControl
                    variant="outlined"
                    size="small"
                    className="formControl col-md-12"
                  >
                    <Dropdown
                      appendTo={document.getElementById("root")}
                      value={this.state.ProductId}
                      //value={this.props.ProductData}
                      onChange={this.handleChange}
                      options={this.props.ProductData}
                      optionValue="value"
                      optionLabel="label"
                      className="form-control"
                      placeholder="Select Product*"
                      name="ProductId"
                      filter
                    />
                  
                  </FormControl>
                  {this.state.formError.ProductId !== "" ? (
                    <div className="error">{this.state.formError.ProductId}</div>
                  ) : (
                    ""
                  )}
                </div>

                {/* <div className="col-md-6 pt-3">
                                    <TextField onChange={this.handleChange} value={this.state.FromNo} name="FromNo" size="small" variant="outlined" className="fullwidth" label="From No*" />
                                    {this.state.formError.FromNo !== '' ?
                                        <div className='error'>{this.state.formError.FromNo}</div> : ''}
                                </div> */}
                <div className="col-md-6 pt-2">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.FromNo}
                    name="FromNo"
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="From No*"
                  />
                  {this.state.formError.FromNo !== "" ? (
                    <div className="error">{this.state.formError.FromNo}</div>
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="col-md-6 pt-3">
                                    <TextField onChange={this.handleChange} value={this.state.ToNo} name="ToNo" size="small" variant="outlined" className="fullwidth" label="To No*" />
                                    {this.state.formError.ToNo !== '' ?
                                        <div className='error'>{this.state.formError.ToNo}</div> : ''}
                                </div> */}
                <div className="col-md-6 pt-2 mt-2">
                  <TextField
                    onChange={this.handleChange}
                    disabled
                    value={this.state.ToNo}
                    name="ToNo"
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="To No*"
                  />
                  {/* {this.state.formError.ToNo !== '' ?
                                        <div className='error'>{this.state.formError.ToNo}</div> : ''} */}
                </div>
                <div className="col-md-6 pt-3">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.Qty}
                    name="Qty"
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Qty*"
                  />
                  {this.state.formError.Qty !== "" ? (
                    <div className="error">{this.state.formError.Qty}</div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-md-6 pt-3">
                  <TextField
                    onChange={this.handleChange}
                    value={this.state.BatchNo}
                    name="BatchNo"
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Batch No"
                  />
                  {/* {this.state.formError.BatchNo !== '' ?
                                        <div className='error'>{this.state.formError.BatchNo}</div> : ''} */}
                </div>

                <div className="col-md-6 mapping_submitbtncol pt-3">
                  {this.state.IsAdd === true ? (
                    <Button
                      className="mr-2"
                      icon="pi pi-plus"
                      label="Available mapping series"
                      onClick={this.openDialogue}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <Dialog
                  header={"Available Series"}
                  modal
                  dismissableMask={false}
                  visible={this.props.showDialogue}
                  style={{ width: "50vw" }}
                  onHide={this.onHidee}
                >
                  <div className="datatable-selection-demo">
                    <div className="card">
                      <Toast ref={(el) => (this.toast = el)} />

                      {this.props.Issueseries ? (
                        <DataTable
                          value={this.props.Issueseries}
                          scrollable
                          responsive={true}
                          selectionMode="checkbox"
                          selection={this.props.selectedProduct}
                          onSelectionChange={(e) =>
                            this.setState({ selectedProduct: e.value })
                          }
                          dataKey="id"
                          responsiveLayout="scroll"
                          onRowSelect={this.onRowSelect}
                        >
                          <Column
                            selectionMode="single"
                            headerStyle={{ width: "6em" }}
                          ></Column>
                          <Column field="FromNo" header="From No" sortable></Column>
                          <Column field="ToNo" header="To No" sortable></Column>
                          <Column field="Qty" header="Quantity" sortable></Column>
                        </DataTable>
                      ) : (
                        <h4 className="text-center"> No Data Available </h4>
                      )}
                      <div className="col-md-12 mt-4 text-center">
                        <Button
                          hidden={true}
                          label={this.state.buttonLabel}
                          onClick={this.submitseries}
                          icon="pi pi-check"
                        />
                      </div>
                    </div>
                  </div>
                </Dialog>

                <div className="col-md-12 mapping_submitbtncol mt-5 text-center">
                 

                  <Button
                    label={this.state.buttonLabel}
                    onClick={this.submitForm}
                    icon="pi pi-check"
                     className="p-button-success"
                  />
                </div>

                <div className="col-md-12">
                  Note: Fields marked as (*) are required
                </div>
              </div>
           </div>
          {/* </form> */}
        </Dialog>

        <Dialog
          header="Confirmation"
          visible={this.state.displayConfirmation}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.setState({ displayConfirmation: false })}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>Are you sure you want to InActive?</span>
          </div>
        </Dialog>
        <Dialog
          header={"Failed Mappings Data"}
          modal
          dismissableMask={false}
          visible={this.props.showErrorDialog}
          style={{ width: "50vw" }}
          onHide={this.onHideError}
        >
          <div className="datatable-selection-demo">
            <div className="card">
              <Toast ref={(el) => (this.toast = el)} />

              {this.props.ErrorData ? (
                <DataTable
                  value={this.props.ErrorData}
                  scrollable
                  responsive={true}
                  dataKey="id"
                  responsiveLayout="scroll"
                >
                  <Column
                    field="ProductCode"
                    header="Product Code"
                    sortable
                  ></Column>
                  <Column field="FromNo" header="From No" sortable></Column>
                  <Column field="ToNo" header="To No" sortable></Column>
                  <Column field="Reason" header="Reason" sortable></Column>
                </DataTable>
              ) : (
                <h4 className="text-center"> No Data Available </h4>
              )}
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('state.mapping.Issueseries', state.mapping.Issueseries);
  //console.log('state.mapping.issueData', state.mapping.issueData);
  return {
    MappingData: state.mapping.items,
    ProductData:
      (typeof state.product.prdctddl !== "undefined" &&
        state.product.prdctddl !== null) === true
        ? state.product?.prdctddl
        : null,
        
    Issueseries: state.mapping.Issueseries,
    MaxFromNo:
      state.mapping.issueData != null ? state.mapping.issueData[0].FromNo : "",
    showDialog: state.mapping.showDialog,
    showDialogue: state.mapping.showDialogue,
    loading: state.company.loding,
    showErrorDialog: state.mapping.showErrorDialog,
    ErrorData: state.mapping.ErrorData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(mappingActions.getAll(obj));
    },
    fetchProductApi: (obj) => {
      dispatch(productMasterActions.getProductName(obj));
    },
    getToNumber: () => {
      dispatch(mappingActions.GetToNo());
    },
    GetAvailableseries: (data) => {
      dispatch(mappingActions.GetAvailableseries(data));
    },
    createMapping: (machine,obj) => dispatch(mappingActions.createMapping(machine,obj)),
    updateMapping: (machine,obj) => dispatch(mappingActions.updateMapping(machine,obj)),
    onHideShow: (isbool) => dispatch(mappingActions.onHideShow(isbool)),
    onHideShoww: (isbool) => dispatch(mappingActions.onHideShoww(isbool)),
    onHideShowError: (isbool) =>
      dispatch(mappingActions.onHideShowError(isbool)),
    getPrdctDDL: () => dispatch(productMasterActions.getPrdctDDL()),
    loadingData: (isLoding) => dispatch(mappingActions.loadingData(isLoding)),
    UploadMapping: (obj, tblResponse) => {
      dispatch(mappingActions.UploadMapping(obj, tblResponse));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Mapping);
